import variables from '../variables';

const primary = {
  main: variables.themeColors.primary,
  dark: variables.themeColors.primary,
  light: variables.themeColors.primaryLight,
};

export default primary;
